import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './SearchResult.css';

const PlaylistItem = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [showSavePopup, setShowSavePopup] = useState(false);
  const [playlistName, setPlaylistName] = useState('');
  const [playlistDescription, setPlaylistDescription] = useState('');
  const navigate = useNavigate();
  const { playlistId } = useParams();

  const API_LIST = [
    'AIzaSyAM9R1vr9t6GSrazqGtw5t8RBKmz2Q17dk',
    'AIzaSyCvaktMcshCgWbahXn7JuJcmhUlSR5ZxAA',
    'AIzaSyBboFo9umdEW03mwz8IdLsRVWXEeAyokdw',
    'AIzaSyAmw-1dYBqj1MIqccmtfeLWfgzYqROkylY',
    'AIzaSyA-xoSvUcnAYUK2v6sTeJtQT4NG9JxWrQg',
    'AIzaSyDwCaQVTwJsau514qhaWTMBlZ80iQgKLtM',
  ];

  const API_KEY = API_LIST[Math.floor(Math.random() * API_LIST.length)];
  const maxResults = 100;

  /* ---------- SAFE THUMBNAIL ---------- */
  const getThumbnail = (item) =>
    item?.snippet?.thumbnails?.medium?.url ||
    item?.snippet?.thumbnails?.high?.url ||
    item?.snippet?.thumbnails?.default?.url ||
    'https://via.placeholder.com/320x180?text=No+Thumbnail';

  useEffect(() => {
    const loadPlaylistData = async () => {
      if (!playlistId) return;

      setSearchResults([]);

      const saved = JSON.parse(localStorage.getItem('savedPlaylists') || '[]')
        .find(p => p.id === playlistId);

      if (saved?.items?.length) {
        setSearchResults(saved.items);
        sessionStorage.setItem(`playlist_${playlistId}`, JSON.stringify(saved.items));
        return;
      }

      const sessionData = sessionStorage.getItem(`playlist_${playlistId}`);
      if (sessionData) {
        setSearchResults(JSON.parse(sessionData));
        return;
      }

      const fetchWithPagination = async (token = '') => {
        try {
          const res = await fetch(
            `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${playlistId}&key=${API_KEY}&maxResults=${maxResults}&pageToken=${token}`
          );
          const data = await res.json();

          if (!data?.items) throw new Error('Invalid API response');

          setSearchResults(prev => {
            const validItems = data.items.filter(
              i => i?.snippet?.resourceId?.videoId
            );
            const merged = [...prev, ...validItems];
            sessionStorage.setItem(`playlist_${playlistId}`, JSON.stringify(merged));
            return merged;
          });

          if (data.nextPageToken) {
            await fetchWithPagination(data.nextPageToken);
          }
        } catch (err) {
          window.open(`https://www.youtube.com/playlist?list=${playlistId}`, '_blank');
          navigate(-1);
        }
      };

      fetchWithPagination();
    };

    loadPlaylistData();
  }, [playlistId, navigate, API_KEY]);

  const isPlaylistSaved = () =>
    JSON.parse(localStorage.getItem('savedPlaylists') || '[]')
      .some(p => p.id === playlistId);

  const handleSaveToLocalStorage = () => {
    if (!playlistName.trim()) return alert('Playlist name required');

    const data = {
      id: playlistId,
      name: playlistName,
      description: playlistDescription,
      items: searchResults,
      savedAt: new Date().toISOString(),
    };

    const existing = JSON.parse(localStorage.getItem('savedPlaylists') || '[]');
    const idx = existing.findIndex(p => p.id === playlistId);

    idx >= 0 ? (existing[idx] = data) : existing.push(data);
    localStorage.setItem('savedPlaylists', JSON.stringify(existing));

    setShowSavePopup(false);
    setPlaylistName('');
    setPlaylistDescription('');
    alert('Playlist saved!');
  };

  if (!playlistId) return <p>Not available.</p>;

  return (
    <div>
      <br /><br /><br />
      <h4 className="text-center text">Playlist</h4>

      {searchResults.length > 0 && (
        <div className="text-center mb-3">
          <button
            className={`btn ${isPlaylistSaved() ? 'btn-success' : 'btn-primary'}`}
            onClick={() => setShowSavePopup(true)}
          >
            {isPlaylistSaved() ? 'Update Playlist' : 'Save Playlist'}
          </button>
        </div>
      )}

      <hr />

      <div className="container">
        <div className="row">
          {searchResults.map(item => {
            const videoId = item?.snippet?.resourceId?.videoId;
            if (!videoId) return null;

            return (
              <div key={item.id} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                <div className="card">
                  <Link to={`/Player/${playlistId}/${videoId}`}>
                    <img
                      src={getThumbnail(item)}
                      className="card-img-top"
                      alt={item?.snippet?.title || 'Video'}
                    />
                  </Link>
                  <div className="card-body">
                    <Link to={`/Player/${playlistId}/${videoId}`} className="maincard1">
                      <h5 className="card-title">
                        {item?.snippet?.title || 'Untitled'}
                      </h5>
                    </Link>
                    <p className="font-weight-bold">
                      {item?.snippet?.channelTitle || 'Unknown Channel'}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* SAVE MODAL */}
      {showSavePopup && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h5>Save Playlist</h5>

            <input
              className="form-control mb-2"
              placeholder="Playlist Name"
              value={playlistName}
              onChange={e => setPlaylistName(e.target.value)}
            />

            <textarea
              className="form-control mb-3"
              rows="3"
              placeholder="Description (optional)"
              value={playlistDescription}
              onChange={e => setPlaylistDescription(e.target.value)}
            />

            <div className="d-flex justify-content-end">
              <button className="btn btn-secondary me-2" onClick={() => setShowSavePopup(false)}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSaveToLocalStorage}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      <br /><br />
    </div>
  );
};

export default PlaylistItem;
